// Прогресс доп. набора «+57 карточек» для конкретного пользователя.
// Бэк (gamesQueries.GetGameModels) отдаёт две булевы:
//   ownerFinishedExtended   — прошёл ли все 57 игрок game.userId
//   invitedFinishedExtended — прошёл ли все 57 игрок game.invitedUserId
// Здесь выбираем «свой»/«партнёр» по текущему id. Используется items 14/15/20a.

export function userFinishedExtended(game, userId) {
  if (!game || userId == null) return false;
  return +userId === +game.userId
    ? !!game.ownerFinishedExtended
    : !!game.invitedFinishedExtended;
}

export function partnerFinishedExtended(game, userId) {
  if (!game || userId == null) return false;
  return +userId === +game.userId
    ? !!game.invitedFinishedExtended
    : !!game.ownerFinishedExtended;
}

export function userFinishedBase(game, userId) {
  if (!game || userId == null) return false;
  return +userId === +game.userId
    ? !!game.ownerFinishedBase
    : !!game.invitedFinishedBase;
}

// item 20a: игроку нужно пройти набор +57 (набор куплен, базу он уже прошёл,
// но свои 57 карт ещё не отвечал). Пока true — на «Играть» зелёный кружок и
// поп-ап-приглашение «Продолжить?».
export function needsExtended57(game, userId) {
  return (
    !!game &&
    !!game.hasExtendedSet &&
    userFinishedBase(game, userId) &&
    !userFinishedExtended(game, userId)
  );
}

// Поддерживает ли текущий payload игры новые поля (иначе — старый кэш/ответ до
// деплоя бэка; вызывающий код может не применять +57-гейт, чтобы не сломать флоу)
export function hasExtendedProgressData(game) {
  return !!game && game.ownerFinishedExtended !== undefined;
}
